import React from "react";

const GenerateSection = ({ handleGenerateIDCards, loading }) => {
  return (
    <div className="generate-section">
      <h1>Generate ID Cards</h1>
      <button
        onClick={handleGenerateIDCards}
        disabled={loading}
        style={{
          padding: "10px 20px",
          backgroundColor: "#e74c3c",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        {loading ? "Generating..." : "Generate ID Cards"}
      </button>
    </div>
  );
};

export default GenerateSection;